'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./headlessui.prod.cjs')
} else {
  module.exports = require('./headlessui.dev.cjs')
}
